module.exports = __webpack_public_path__ + "static/img/hb_58-min.7434a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_58-min.png
// module id = Wn1+
// module chunks = 1